import { defineStore } from 'pinia';
import { RouteLocationNormalized } from 'vue-router';
import { getStorage, setStorage } from 'xag-ai-utils';
interface BreadcrumbProps {
  link?: boolean;
  fullPath: string;
  label: string;
}

interface State {
  nav: BreadcrumbProps[];
}

export interface BreadNavigationHookAfter {
  (params: { to: RouteLocationNormalized; root: BreadcrumbProps[] }): any;
}

// useStore could be anything like useUser, useCart
// the first argument is a unique id of the store across your application
export const useNavStore = defineStore<
  string,
  State,
  any,
  {
    resetLocal: () => void;
    handlerRoute: BreadNavigationHookAfter;
  }
>('breadcrumb', {
  state: () => {
    return {
      nav: getStorage('main-nav') || [],
      position: getStorage('position') || 0,
    };
  },
  getters: {
    breadcrumb() {
      return this.nav;
    },
  },
  actions: {
    handlerRoute({ to, root }) {
      // // console.log(window.history.state);
      const historyPos = history.state.position;
      // // console.log(this.position, historyPos);
      // // console.log(to);
      if (!to.meta || !to.meta.title) {
        return;
      }
      const result = {
        label: to.meta.title,
        link: true,
        fullPath: to.fullPath,
      };
      // 触发两次
      if (this.position == historyPos) {
        const len = this.nav.length;
        if (window.history.state.replaced) {
          // 替代&刷新&后退
          const pos = this.position - historyPos; // 0
          if (pos >= 0) {
            const idx = len - 1 - pos;
            this.nav.splice(idx, pos + 1, result);
          }
        }
        this.resetLocal();
        return;
      }

      // 清空路由
      if (to.meta.root) {
        this.nav.length = 0;

        if (to.meta.nav && Array.isArray(to.meta.nav)) {
          this.nav.push(...to.meta.nav);
        } else {
          this.nav.push(...root);
        }

        this.nav.push(result);
        this.resetLocal();
        return;
      }
      const len = this.nav.length;
      if (this.position > historyPos) {
        // name的方式
        // 返回

        const index = this.nav.findIndex((i) => i.fullPath === to.fullPath);

        const delIndex = index + 1;
        if (index !== -1 && delIndex <= len - 1) {
          this.nav.splice(delIndex, len - delIndex);
          this.resetLocal();
          return;
        }
      } else {
        // 前进
        this.nav.push(result);
      }
      this.resetLocal();
    },

    resetLocal() {
      this.position = history.state.position;
      setStorage('position', this.position);
      setStorage('main-nav', this.nav);
      // console.log(this.nav);
    },
  },
});
